import { Component, EventEmitter, Injector, Input, OnInit, Output, ViewChild } from '@angular/core';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { Table } from 'primeng/table';
import { deepCopy, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { AbstractControl, FormBuilder, FormGroup } from '@angular/forms';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { BillService } from '../../../service/bill.service';
import { HttpErrorResponse } from '@angular/common/http';
import * as ValidationUtils from 'src/app/core/utils/validation-functions';

@Component({
  selector: 'laas-bill-add',
  templateUrl: './bill-add.component.html',
  styleUrls: ['./bill-add.component.scss']
})
export class BillAddComponent extends SessionBaseComponent implements OnInit {
  isVisible: boolean;
  tableColumns: any[];
  selectedTableColumns: any[];
  addValue: any;
  tableValue: any[];
  addForm: FormGroup;
  selectedRow: any;
  selectMode: boolean;
  newRowFormat: any;
  cloneRow: any;
  previousSelectedRow: any;
  deletedRrowIdList: any[];
  facility: any;
  userType: any;
  forwarderCode: any;
  verifyParams: any;
  saveParams: any;
  saveImportBillResponse: any[];
  saveBillingImport: any[];
  billingImportSeqNoList: any[];
  billingImportSearchsRequest: any;
  isLoading: boolean;

  billTypeOptions: any[];
  bookingVendorOptions: any[];
  accountCodeDetailOptions: any[];
  currencyOptions: any[];
  invoiceTypeOptions: any[];
  paymentMethodOptions: any[];
  termsIdOptions: any[];
  inOutTypeOptions: any[];
  billCorpOptions: any[];
  carrierPaymentByOptions: any[];
  submitted: boolean = false;
  amountValid: boolean = false;
  today: Date = new Date();

  failList: any[];

  @ViewChild('billAddTable') dataTable!: Table;
  constructor(
    injector: Injector,
    private formBuilder: FormBuilder,
    private commonDataService: CommonDataService,
    private dropdownOptionsService: DropdownOptionsService,
    private facilityService: FacilityService,
    private billService: BillService,


  ) {
    super(injector);
    this.isVisible = false;
    this.selectMode = false;
    this.isLoading = false;

    this.addValue = 1;

    this.tableColumns = this.tableTranslation();
    this.selectedTableColumns = this.tableColumns;
    this.deletedRrowIdList = [];

    this.tableValue = [];
    this.selectedRow = [];
    this.billTypeOptions = [];
    this.bookingVendorOptions = [];
    this.accountCodeDetailOptions = [];
    this.currencyOptions = [];
    this.invoiceTypeOptions = [];
    this.paymentMethodOptions = [];
    this.termsIdOptions = [];
    this.inOutTypeOptions = [];
    this.billCorpOptions = [];
    this.carrierPaymentByOptions = [];
    this.billingImportSeqNoList = [];

    this.failList = [];
    this.saveBillingImport = [];
    this.saveImportBillResponse = [];

    this.addForm = this.formBuilder.group({
      addValue: 1
    });

    this.newRowFormat = {
      rowId: '1',
      billingNo: null,
      inOutType: null,
      billCorp: null,
      billType: 'STANDARD',
      carrierPaymentBy: '12345',
      accountCode: '21264.3306.001',
      guiCurrency: 'TWD',
      guiAmount: 0,
      amount: 0,
      linePayCurrency: 'TWD',
      invoiceType: '0',
      guiDt: null,
      guiNo: null,
      vendorDescription: null,
      paymentMethod: 'CHECK',
      termsId: "10000",
      dueDt: null,
      billingNoCheck: "FALSE",
      facility: this.laasSetting.facility
    };

    this.verifyParams = {
      guiId: null,
      facility: null,
      userType: null,
      forwarderCode: null
    }

    this.saveParams = {
      billingImports: null,
      userId: null
    }

    this.billingImportSearchsRequest = {
      billingImportSearchs: []
    }


    this.tableValue.unshift(deepCopy(this.newRowFormat));

  }

  @Input() get visible(): any {
    return this.isVisible;
  }

  @Input() get selectedColumns(): any[] {
    return this.selectedTableColumns;
  }

  @Output() visibleChange = new EventEmitter<any>();

  set visible(value: any) {
    this.isVisible = value;
  }

  async ngOnInit(): Promise<void> {
    super.ngOnInit();

    this.selectedRow = this.tableValue[0];
    this.selectedRow.dueDt = new Date();
    this.selectedRow.guiDt = new Date();
    this.previousSelectedRow = deepCopy(this.selectedRow);

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'BillType').subscribe({
      next: result => {
        this.billTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });

      }
    });



    this.dropdownOptionsService.getForwarderOptions()
      .subscribe({
        next: result => {
          this.bookingVendorOptions = result;
        }
      });

    this.dropdownOptionsService.getDetailBillAccountCode()
      .subscribe({
        next: result => {
          this.accountCodeDetailOptions = [...result].map((x: any) => {
            return {
              label: `${x.optionDesc}`,
              value: x.optionCode,
            };
          });
        }
      });

    this.facilityService.getCurrencyOptions().subscribe({
      next: result => {
        this.currencyOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionCode}-${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'InvoiceType').subscribe({
      next: result => {
        this.invoiceTypeOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });

    this.facilityService.getExpenseOptions('PaymentMethod', null).subscribe({
      next: result => {
        this.paymentMethodOptions = [...result].map((x: any) => {
          return {
            value: `${x.optionCode}`,
            label: `${x.optionCode}-${x.optionDesc}`,
          };
        });
      }
    });

    this.facilityService.getExpenseOptions('SHT_BILL_ORIGIN.TERMS', null).subscribe({
      next: result => {
        this.termsIdOptions = [...result].map((x: any) => {
          return {
            value:  x.optionCode,
            label: `${x.optionCode} - ${x.optionDesc}`,
          };
        });
      }
    });

    this.facilityService.getLetterOrgOptions(this.laasSetting.facility, '').subscribe({
      next: result => {
        this.billCorpOptions = [...result].map((x: any) => {
          return {
            label: `${x.legalEntityOUCode} - ${x.legalEntityOUName}`,
            value: x.legalEntityOUCode,
          };
        });
      }
    });

    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'InOutType').subscribe({
      next: result => {
        this.inOutTypeOptions = [...result].map((x: any) => {
          return {
            value: x.codeKey,
            label: `${x.codeKey}-${x.codeDesc}`,
          };
        });
      }
    });

    this.dropdownOptionsService.getForwarderOptions()
    .subscribe({
      next: result => {
        this.carrierPaymentByOptions = [...result].map((x: any) => {
          return {
            label: `${x.optionDesc}`,
            value: x.optionCode,
          };
        });
      }
    });

  }

  dialogVisibleChange(value: boolean): void {
    this.visibleChange.emit(value);
  }

  tableTranslation(): any[] {

    var fields: string[];
    var jsons: string[];
    var tmpcolumn: any[] = [];


    fields = ['rowId', 'billingNo', 'inOutType', 'billCorp', 'billType', 'carrierPaymentBy', 'accountCode', 'guiCurrency',
      'guiAmount', 'amount', 'linePayCurrency', 'invoiceType', 'guiDt', 'guiNo', 'vendorDescription', 'paymentMethod', 'termsId', 'dueDt'];

    jsons = ['BillSearch.BillAdd.RowId', 'BillSearch.MainTable.Column.InOutKey', 'BillSearch.MainTable.Column.InOutType',
      'BillSearch.MainTable.Column.BillCorp', 'BillSearch.MainTable.Column.BillType', 'BillSearch.MainTable.Column.VendorName',
      'BillSearch.MainTable.Column.AccountCode', 'BillSearch.MainTable.Column.GUICurrency', 'BillSearch.MainTable.Column.GUIAmount',
      'BillSearch.MainTable.Column.ApplyAmount', 'BillSearch.MainTable.Column.LinePayCurrency', 'BillSearch.MainTable.Column.InvoiceType',
      'BillSearch.MainTable.Column.GUIDt', 'BillSearch.MainTable.Column.GUINo', 'BillSearch.MainTable.Column.VendorDescription',
      'BillSearch.MainTable.Column.PaymentMethod', 'BillSearch.MainTable.Column.TermsId', 'BillSearch.MainTable.Column.DueDt'];

    for (let i = 0; i < fields.length; i++) {
      this.translateService.get(jsons[i])
        .subscribe((translation: string) => {
          //建立日期 || 更新時間
          if (i == 12 || i == 17) {
            tmpcolumn[i] = ({ field: fields[i], header: translation, dataType: 'date', sort: true })
          } else {
            tmpcolumn[i] = ({ field: fields[i], header: translation, sort: true })
          }
        });
    }
    return tmpcolumn;
  }



  onRowClick(rowData: any) {
    this.selectedRow = rowData;
    this.selectMode = true;
    this.doSwitchRow();
  }

  doSwitchRow() {
    this.dataTable.cancelRowEdit(this.previousSelectedRow);
    this.dataTable.initRowEdit(this.selectedRow);
    this.previousSelectedRow = deepCopy(this.selectedRow);
  }


  addBtnClick() {
    this.cloneRow = deepCopy(this.newRowFormat);
    this.cloneRow.rowId = this.getMaxRowId();
    for (let i = 0 ; i < this.addValue ; i++){
      this.dataTable.value.unshift(deepCopy(this.cloneRow));
      this.getLastRowId();

      this.selectedRow = this.tableValue[0];
      this.selectedRow.guiDt = new Date();
      this.selectedRow.dueDt = new Date();
    }
    this.dataTable.cancelRowEdit(this.previousSelectedRow);
    this.dataTable.initRowEdit(this.selectedRow);
    this.previousSelectedRow = deepCopy(this.selectedRow);
  }

  getMaxRowId() {
    if (this.tableValue.length > 0) {
      return this.tableValue.length + 1;
    } else {
      return 1;
    }
  }

  getLastRowId() {
    let rowId = 1;
    for (const row of this.tableValue) {
      row.rowId = rowId;
      rowId = rowId + 1;
    }

  }

  deleteBtnClick() {
    for (const x of this.tableValue) {
      if (x.rowId === this.selectedRow.rowId) {
        // 紀錄刪除列的rowId
        if (!isNullOrEmpty(this.selectedRow.rowId)) {
          this.deletedRrowIdList.push(this.selectedRow.rowId)
        }
        // 刪除後關閉行編輯
        this.dataTable.cancelRowEdit(this.selectedRow);
        this.tableValue.splice(this.tableValue.indexOf(x), 1);
        // 刪除後將row指到下一行
        this.selectedRow = this.tableValue[0];
        this.previousSelectedRow = deepCopy(this.selectedRow);
        break;
      }
    }
    this.getLastRowId();
  }

  focusOutFunction(rowIndex: any) {
    if (this.selectedRow.billingNo) {
      let searchVerifyParams = deepCopy(this.verifyParams);
      searchVerifyParams.userType = this.userProfile.userType;
      searchVerifyParams.facility = this.laasSetting.facility;
      searchVerifyParams.guiId = this.tableValue[rowIndex].billingNo;
      if (this.userProfile.userType == "Forwarder") {
        searchVerifyParams.forwarderCode = this.userProfile.roles[0].scopes[0].forwarderCode;
      }
      this.billService.checkBillData(searchVerifyParams).subscribe({
        next: result => {
          switch (result.inOutType) {
            case "I-IN":
              this.tableValue[rowIndex].carrierPaymentBy = result.forwarder;
              this.tableValue[rowIndex].inOutType = "I";
              break;
            case "A-IMPORT":
              this.tableValue[rowIndex].carrierPaymentBy = result.billObject;
              this.tableValue[rowIndex].inOutType = "A";
              this.tableValue[rowIndex].accountCode = "21264.0000.001";
              break;
            case "B-EXPORT":
              this.tableValue[rowIndex].carrierPaymentBy = result.billObject;
              this.tableValue[rowIndex].inOutType = "B";
              this.tableValue[rowIndex].accountCode = "26214.Z027.001";
              break;
            case "O-OUT":
              this.tableValue[rowIndex].carrierPaymentBy = result.forwarder;
              this.tableValue[rowIndex].inOutType = "O";
              break;
          }
          this.tableValue[rowIndex].billCorp = result.billCorp;
          this.tableValue[rowIndex].paymentMethod = result.paymentMethod;
          this.tableValue[rowIndex].termsId = (result.termsId);
          this.tableValue[rowIndex].billingNoCheck = result.billingNoCheck;
        },
        error: (err: HttpErrorResponse) => {
          this.tableValue[rowIndex].billingNoCheck = "FALSE";
          switch (err.error.errorCode) {
            case "0204":
              this.toastService.warn(this.translateService.instant("BillSearch.BillAdd.Error.InoutKeyInvalid") + ":" + searchVerifyParams.guiId);
              break;
            case "0205":
              this.toastService.warn(this.translateService.instant("BillSearch.BillAdd.Error.BrandNull") + ":" + searchVerifyParams.guiId);
              break;
            default:
              this.toastService.error(this.translateService.instant("Common.Message.UnknowError"))
              break;
            }
        },
      })
    }
  }

  showTableValidationMessage(value:  string | null, submitted: boolean): boolean {
    return !ValidationUtils.showTableValidationMessage(value, submitted);
  }

  focusOutGUIAmount() {
    this.selectedRow.amount = this.selectedRow.guiAmount;
  }

  saveBtnClick() {
    this.submitted = true;
    this.amountValid = false;
    this.failList = [];
    if (this.tableValue.length > 0){
      for (const rowData of this.tableValue) {
        if (isNullOrEmpty(rowData.billingNo)) {
            this.toastService.warn(this.translateService.instant('BillSearch.BillAdd.Error.BillingNoInvalid'));
            return;
        }

        if (rowData.billingNoCheck == "FALSE" || rowData.billingNoCheck == "False") {
          this.failList.push(rowData.billingNo);
        }
        if (!this.validAmount(rowData.amount)) {
          this.amountValid = true;
          break;
        }
      }

      if (this.failList.length > 0) {
        this.toastService.warn(this.translateService.instant('BillSearch.BillAdd.Message.Failed', { list: this.failList }));
      } else if (this.amountValid){
        this.toastService.warn(this.translateService.instant('BillSearch.BillAdd.Error.AmountInvalid'));
      } else {
        this.doSave();
      }
    } else {
      this.toastService.warn(this.translateService.instant('BillSearch.BillAdd.Message.Nodata'));
    }
  }


  doSave() {
    this.isLoading = true;
    this.saveParams.billingImports = this.tableValue;
    this.saveParams.userId = this.userProfile.userName;
    //做儲存動作 做Expense的saveBillingImport
    this.billService.saveBillingImport(this.saveParams).subscribe({
      next: result => {
        this.saveImportBillResponse = result;
        this.doImportBilling();
      },
      error: (err: HttpErrorResponse) => {
        this.toastService.error(this.translateService.instant('BillSearch.BillAdd.Message.Error'));
      },
    })
  }

  doImportBilling() {
    //做Expense的ImportBilling
    this.billingImportSearchsRequest.billingImportSearchs = [];
    if (this.saveImportBillResponse.length > 0) {
      for (const saveImportBill of this.saveImportBillResponse) {
        this.billingImportSearchsRequest.billingImportSearchs.push({ billingImportSeqNo: saveImportBill.billingImportSeqNo, userType: this.userProfile.userType });
      }
      this.billService.importBilling(this.billingImportSearchsRequest).subscribe({
        next: result => {
          this.toastService.success(this.translateService.instant('BillSearch.BillAdd.Message.Success') + this.tableValue.length);

          this.isLoading = false;
          this.dialogVisibleChange(false);
        },
        error: (err: HttpErrorResponse) => {
          switch (err.error.errorCode) {
            case "0201":
              this.toastService.warn(this.translateService.instant("BillSearch.BillAdd.Error.OldInvoice"));
              break;
            case "0202":
              this.toastService.warn(this.translateService.instant("BillSearch.BillAdd.Error.TermsNull"));
              break;
            case "203":
              this.toastService.warn(this.translateService.instant("BillSearch.BillAdd.Error.RateNull"));
              break;
            case "0005":
            case "0006":
              this.toastService.warn(err.error.errorMsg);
              break;
            default:
              this.toastService.error(this.translateService.instant("Common.Message.UnknowError"))
              break;
          }
          this.isLoading = false;
        },
      })
    }
  }

  validAmount(amount: any): boolean {
    if (isNullOrEmpty(amount) || amount == 0) {
      return false;
    }
    return true;
  }
}
